import { render, staticRenderFns } from "./MlFooter.vue?vue&type=template&id=209a1fca&scoped=true"
import script from "./MlFooter.vue?vue&type=script&lang=js"
export * from "./MlFooter.vue?vue&type=script&lang=js"
import style0 from "./MlFooter.vue?vue&type=style&index=0&id=209a1fca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209a1fca",
  null
  
)

export default component.exports